export default function quaseIgual(
  a: number,
  b: number,
  tolerancia = 0.00001,
): boolean {
  if (b > a) return Math.abs(b - a) <= tolerancia;
  return Math.abs(a - b) <= tolerancia;
}
